var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import classNames from 'classnames';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Signals from '../../../../signals/Signals';
/**
 *
 */
var ConfirmModal = /** @class */ (function (_super) {
    __extends(ConfirmModal, _super);
    /**
     *
     * @param props
     */
    function ConfirmModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            show: props.show
        };
        _this.cancel = _this.cancel.bind(_this);
        _this.confirm = _this.confirm.bind(_this);
        _this.show = _this.show.bind(_this);
        Signals.ShowConfirmModal.add(_this.show);
        return _this;
    }
    /**
     *
     */
    ConfirmModal.prototype.componentWillUnmount = function () {
        Signals.ShowConfirmModal.remove(this.show);
    };
    /**
     *
     * @return {*}
     */
    ConfirmModal.prototype.render = function () {
        var classes = classNames({
            'confirm-modal': true,
            'confirm-modal--showing': this.state.show
        });
        { /* Confirm Modal */
        }
        return (React.createElement(Modal, { className: classes, isOpen: this.state.show },
            React.createElement(ModalHeader, { toggle: this.cancel }, this.state.title),
            React.createElement(ModalBody, null,
                React.createElement("div", { dangerouslySetInnerHTML: { __html: this.state.body } })),
            React.createElement(ModalFooter, null,
                React.createElement("button", { className: "btn btn-outline-primary", onClick: this.cancel }, this.state.cancelText),
                React.createElement("button", { className: 'btn btn-' + this.state.color, onClick: this.confirm }, this.state.confirmText))));
    };
    /**
     *
     */
    ConfirmModal.prototype.cancel = function () {
        this.setState({ show: false });
        if (this.state.onCancel) {
            this.state.onCancel();
        }
    };
    /**
     *
     */
    ConfirmModal.prototype.confirm = function () {
        this.setState({ show: false });
        if (this.state.onConfirm) {
            this.state.onConfirm();
        }
    };
    /**
     *
     * @param title
     * @param body
     * @param confirmText
     * @param cancelText
     * @param onConfirm
     * @param onCancel
     * @param color
     */
    ConfirmModal.prototype.show = function (title, body, confirmText, cancelText, onConfirm, onCancel, color) {
        if (confirmText === void 0) { confirmText = 'Ok'; }
        if (cancelText === void 0) { cancelText = 'Cancel'; }
        if (onConfirm === void 0) { onConfirm = null; }
        if (onCancel === void 0) { onCancel = null; }
        if (color === void 0) { color = 'primary'; }
        this.setState({
            show: true,
            title: title,
            body: body,
            confirmText: confirmText,
            cancelText: cancelText,
            onConfirm: onConfirm,
            onCancel: onCancel,
            color: color
        });
    };
    return ConfirmModal;
}(React.Component));
export default ConfirmModal;
